import moment from 'moment'
import meta from '@/config/meta'

export default {
  publish: (form) => {
    const { office, client, date, entries, items, status, authors } = form || {}
    const officeIdx = Object.keys(meta.offices).findIndex(key => { return meta.offices[key].slug === office })
    const officeId = Object.keys(meta.offices)[officeIdx >= 0 ? officeIdx : 0]
    const myOffice = meta.offices[officeId]

    const tableEntry = entries && entries.length ? entries.map(it => {
      const { date, time, breaktime, wage, subject, aid } = it
      return [
        { text: date, style: 'tableBody' },
        { text: time, style: 'tableBody' },
        { text: breaktime, style: 'tableBody' },
        { text: wage, style: 'tableBody' },
        { text: authors[aid].name[0], style: 'tableBody' },
        { text: subject, style: 'tableBody', fontSize: 8 }
      ]
    }) : []
    const totalEntryNumber = entries && entries.length ? entries.reduce((prev, it) => {
      const { wage, breaktime } = it
      return prev + (parseFloat(wage || '0') - parseFloat(breaktime || '0'))
    }, 0) : 0
    const tableItem = items && items.length ? items.map(it => {
      const { subject, number, price } = it
      return [
        { text: subject, style: 'tableBody' },
        { text: number, style: 'tableBody' },
        { text: price, style: 'tableBody' },
        { text: `${parseFloat(number || '0') * parseInt(price || '0')}`, style: 'tableBody' }
      ]
    }) : []
    const totalItemNumber = items && items.length ? items.reduce((prev, it) => {
      const { number, price } = it
      return prev + (parseFloat(number || '0') * parseFloat(price || '0'))
    }, 0) : 0
    const paddingNumber = 25 - (tableEntry.length + tableItem.length)
    const tablePadding = paddingNumber > 0 ? Array( paddingNumber).fill([
      { text: '　', style: 'tableBody' },
      { text: '　', style: 'tableBody' },
      { text: '　', style: 'tableBody' },
      { text: '　', style: 'tableBody' },
      { text: '　', style: 'tableBody' },
      { text: '　', style: 'tableBody' },
    ]) : [[ { text: '', border: [false, false, false, false] }]]
    const comments = []
    if (status && status.comments) {
      for (const it of entries) {
        const { date, comment, subject, aid } = it
        if (comment && comment.trim() !== '') {
          comments.push([
            { text: `${date}：${subject}`, style: 'commentDate', border: [ false, false, false, false ] },
            { text: `担当：${authors[aid].name[0]}`, style: 'commentAuthor', border: [ false, false, false, false ]}
          ])
          comments.push([
            { text: comment, style: 'commentBody', colSpan: 2 }
          ])
        }
      }
    }

    return {
      pageSize: 'A4',
      pageMargins: [40, 130, 40, 120],
      header: [
        { text: '個別指導・請求書', style: 'title' },
        { text: `${client.name.join(' ')} 様`, style: 'header' },
        { text: `発行日：${moment(date).format('YYYY年MM月DD日')}`, style: 'issued' },
      ],
      footer: [
        {
          margin: [40, 0, 40, 60],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  border: [true, true, true, true],
                  table: {
                    widths: [85, 60, '*', 50],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          text: '　'
                        },
                        {
                          border: [false, false, false, false],
                          text: '（取扱い窓口）',
                          fontSize: 6
                        },
                        {
                          border: [false, false, false, false],
                          text: [
                            {
                              text: myOffice.document.footer,
                              style: 'companyName'
                            },
                            {
                              text: '\n' + [
                                myOffice.document.address,
                                myOffice.document.phone,
                                myOffice.document.email
                              ].join('\n'),
                              fontSize: 6,
                              lineHeight: 1.1
                            }
                          ]
                        }
                      ]
                    ]
                  }
                }
              ]
            ]
          }
        }
      ],
      content: [
        {
          text: 'お世話になります。 下記の個別指導に関する時間を集計しご請求致します。',
          style: 'message',
          margin: [0, 0, 0, 5]
        },
        {
          table: {
            heights: [20, '*'],
            widths: [70, 70, 40, 40, 40, '*'],
            headerRows: 1,
            body: [
              [
                { text: '指導日', style: 'tableHeader' },
                { text: '対応時間', style: 'tableHeader' },
                { text: '自習・待機', style: 'tableHeader' },
                { text: '指導時間', style: 'tableHeader' },
                { text: '担当', style: 'tableHeader' },
                { text: '備考', style: 'tableHeader' }
              ],
              ...tableEntry,
              // ...tablePadding,
              [{
                text: `合計：${totalEntryNumber}時間`,
                colSpan: 6,
                style: 'tableBody',
                alignment: 'right',
                border: [false, false, false, false],
                margin: [0, 5, 0, 10]
              }]
            ]
          }
        },
        {
          table: {
            heights: [20, '*'],
            widths: ['*', '*', '*', '*'],
            headerRows: 1,
            body: [
              [
                { text: '名目', style: 'tableHeader' },
                { text: '数量', style: 'tableHeader' },
                { text: '単価', style: 'tableHeader' },
                { text: '小計', style: 'tableHeader' }
              ],
              ...tableItem,
              [{
                text: `消費税（10%）：¥${`${Math.round(totalItemNumber * .1)}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`,
                colSpan: 4,
                style: 'tableBody',
                alignment: 'right',
                border: [false, false, false, false],
                margin: [0, 5, 0, 0]
              }],
              [{
                text: `合計：¥${`${Math.round(totalItemNumber * 1.1)}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}`,
                colSpan: 4,
                style: 'tableBody',
                alignment: 'right',
                border: [false, false, false, false],
                margin: [0, 5, 0, 0]
              }]
            ]
          }
        },
        {
          table: {
            heights: [12, 50],
            widths: ['*'],
            body: [
              [
                {
                  text: `合計額を最寄りの銀行から、下記の口座にお振込みください。`,
                  style: 'message',
                  border: [false, false, false, false]
                }
              ],
              [
                {
                  text: [
                    `${myOffice.account.bank}  ${myOffice.account.branch}`,
                    `（${myOffice.account.type}） ${myOffice.account.number}  名義：${myOffice.account.name}`
                  ].join('\n'),
                  style: 'account',
                  margin: [0, 10, 0, 0]
                }
              ]
            ]
          }
        },
        comments.length ? {
          pageBreak: 'before',
          table: {
            widths: ['*', '*'],
            body: [
              ...comments
            ]
          }
        } : []
      ],
      styles: {
        title: {
          fontSize: 18,
          bold: true,
          alignment: 'center',
          margin: [0, 40, 0, 10]
        },
        header: {
          fontSize: 16,
          margin: [40, 0, 40, 0]
        },
        issued: {
          fontSize: 12,
          margin: [40, 0, 40, 0],
          alignment: 'right',
          lineHeight: 2
        },
        subheader: {
          fontSize: 12,
          margin: [40, 0, 40, 0]
        },
        footerNote: {
          fontSize: 6.5,
          margin: [5, 5, 5, 0]
        },
        tableHeader: {
          fontSize: 8,
          alignment: 'center',
          margin: [0, 5, 0, 0]
        },
        tableBody: {
          fontSize: 8,
          alignment: 'center'
        },
        commentDate: {
          fontSize: 10,
          alignment: 'left',
          margin: [0, 5, 0, 0]
        },
        commentAuthor: {
          fontSize: 10,
          alignment: 'right',
          margin: [0, 5, 0, 0]
        },
        commentBody: {
          fontSize: 10,
          alignment: 'left',
          lineHeight: 1.5
        },
        sectionTitle: {
          fontSize: 8,
          lineHeight: 1.2
        },
        sectionSubTitle: {
          fontSize: 6,
          lineHeight: 1.2
        },
        signature: {
          fontSize: 6,
          alignment: 'center',
          margin: [0, 3, 0, 0]
        },
        companyName: {
          fontSize: 10,
          lineHeight: 1.5,
          bold: true
        },
        message: {
          fontSize: 10
        },
        account: {
          fontSize: 12,
          alignment: 'center',
          lineHeight: 1.5
        }
      },
      defaultStyle: {
        font: 'AozoraMincho'
      }
    }
  }
}